import { atom } from 'jotai'

type UserProps = {
  id: string;
  username: string;
  email: string;
  phoneNumber: string;
  cpf: string;
  wallet: {
    amount: number;
  };
}

export const userAtom = atom<UserProps | undefined>(undefined)